import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { FirebaseFeatureFlags } from '@shared/enums/firebase-custom-claims.enum';
import { FeatureFlagService } from '@shared/services/feature-flag.service';
import { Observable, filter, switchMap, take, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SupplierDefaultPageGuard implements CanActivate {
  constructor(
    private _featureFlagService: FeatureFlagService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
    const listingUuid = route.parent?.paramMap.get('listingUuid');

    return this._featureFlagService.getFlagsLoaded().pipe(
      filter(loaded => loaded),
      take(1),
      switchMap(() => this._featureFlagService.getFeatureFlags().pipe(take(1))),
      map(({ flags }) => {
        const hasProMenu = flags.includes(FirebaseFeatureFlags.PRO_MENU);

        return hasProMenu
          ? this.router.createUrlTree(['/su', listingUuid, 'enquiries', 'active-lead', 'requests', 'live'])
          : this.router.createUrlTree(['/su', listingUuid, 'inbox']);
      })
    );
  }
}
